// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__drO2N","gfeWrapper":"CalendarEvent_gfeWrapper__1tDVq"};